import { Component, inject } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, FormGroup } from "@angular/forms";
import { takeUntil } from "rxjs";
import { Actions, Store, ofActionSuccessful } from "@ngxs/store";

import { BasedComponent } from "@shared/components/based.component";
import { InjectDialogData } from "./edit-modal-dialog.constant";
import { CommonModalDialogComponent } from "@shared/components/common-modal-dialog/common-modal-dialog.component";
import { CommonModalDialogOption, ModalDialogButtonType, ModalDialogResult } from "@shared/components/common-modal-dialog/common-modal-dialog.constant";
import { DataUpdateResponseWithAttachmentUrl, WebApiResponseBase } from "@app/shared/classes/general";
import * as AppDataAction from '@app/shared/actions/app-data.action';

@Component({
  selector: 'app-advanced-edit-modal-dialog-based',
  template: ''
})
export abstract class EditModalDialogBasedComponent<T1, T2> extends BasedComponent {
  store = inject(Store);
  actions$ = inject(Actions);
  dialog = inject(MatDialog);
  formBuilder = inject(FormBuilder);

  editForm: FormGroup;
  isCreate: boolean = false;
  basedDialogRef: MatDialogRef<T1>;
  baseData: InjectDialogData<T2>;
  attachmentFile: File;

  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.actions$.pipe(ofActionSuccessful(AppDataAction.UploadAttachment), takeUntil(this.destroy$)).subscribe(_ => this.showSuccessResult());
  }

  dataInit(basedDialogRef: MatDialogRef<T1>, baseData: InjectDialogData<T2>) {
    this.basedDialogRef = basedDialogRef;
    this.baseData = baseData;
  }

  processAfterUpdated = (successResponse: DataUpdateResponseWithAttachmentUrl, errorResponse: WebApiResponseBase) => {
    if (this.attachmentFile && successResponse.putAttachmentS3Url) {
      this.store.dispatch(new AppDataAction.UploadAttachment(successResponse.putAttachmentS3Url, this.attachmentFile));
      return;
    }

    this.processAfterUpdateObject(errorResponse);
  }

  processAfterUpdateObject = (errorResponse: WebApiResponseBase) => {
    if (errorResponse && errorResponse.httpResponseStatus === 500) {
      this.showErrorResult(errorResponse);
    }
    else {
      this.showSuccessResult();
    }
  }

  showSuccessResult = () => {
    const msgDialogRef = this.dialog.open(CommonModalDialogComponent, {
      data: { header: true, message: this.isCreate ? "ml_144043" : "ml_143937", buttonType: ModalDialogButtonType.CLOSE } as CommonModalDialogOption,
      disableClose: false
    });

    msgDialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (this.baseData.successHandler) this.baseData.successHandler();
      this.basedDialogRef.close({ data: ModalDialogResult.OK });
    });
  }

  showErrorResult = (errorResponse: WebApiResponseBase) => {
    var errorMsg = this.getErrorMessage(errorResponse);
    this.dialog.open(CommonModalDialogComponent, {
      data: { header: true, title: this.isCreate ? "ml_144044" : "ml_143947", isErrorMessage: true, message: errorMsg, buttonType: ModalDialogButtonType.CLOSE } as CommonModalDialogOption,
      disableClose: false
    });
  }

  onFileSelected = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      this.attachmentFile = e.target.files[0];
      this.editForm.controls['attachment'].setValue(this.attachmentFile.name);
    }
    else {
      this.attachmentFile = undefined;
    }
  }

  onCancelClick = () => this.basedDialogRef.close({ data: ModalDialogResult.CANCEL });

  hasError = (controlName: string, errorName: string) => this.editForm.controls[controlName].hasError(errorName);
}
